<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Tips - Consejos uso del sistema</h4>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPagina(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
                Buscar
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >add_box</i
                >
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Texto</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="consejo in datosPaginados" :key="consejo.idConsejo">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(consejo.idConsejo)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(consejo.idConsejo)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ consejo.texto }}</td>
          <td>{{ getFormattedDate(consejo.fechaReg, "DD/MM/YYYY") }}</td>
          <td>{{ getFormattedDate(consejo.fechaAct, "DD/MM/YYYY") }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteConsejo(consejo.idConsejo)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idConsejo" class="form-label">IdConsejo</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idConsejo"
                      name="idConsejo"
                      v-model="datoConsejo.idConsejo"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="texto" class="form-label">Texto</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      id="texto"
                      name="texto"
                      v-model="datoConsejo.texto"
                      style="text-transform: uppercase"
                    ></textarea>
                  </div>
                </div>
              </div>
              <button @click.prevent="mostrarOcultarBloque">
                {{
                  mostrarBloque
                    ? "(-) Menos información"
                    : "(+) Más información"
                }}
              </button>
              <div v-if="mostrarBloque" class="mb-3">
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="idUsuarioReg" class="form-label"
                        >IdUsuarioReg</label
                      >
                    </div>
                    <div class="col-10">
                      <input
                        type="text"
                        class="form-control"
                        id="idUsuarioReg"
                        name="idUsuarioReg"
                        v-model="datoConsejo.idUsuarioReg"
                        style="text-transform: uppercase"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="idUsuarioAct" class="form-label"
                        >IdUsuarioAct</label
                      >
                    </div>
                    <div class="col-10">
                      <input
                        type="text"
                        class="form-control"
                        id="idUsuarioAct"
                        name="idUsuarioAct"
                        v-model="datoConsejo.idUsuarioAct"
                        style="text-transform: uppercase"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="fechaReg" class="form-label"
                        >Fecha de registro</label
                      >
                    </div>
                    <div class="col-10">
                      <input
                        type="text"
                        class="form-control"
                        id="fechaReg"
                        name="fechaReg"
                        v-model="datoConsejo.fechaReg"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2">
                      <label for="fechaAct" class="form-label">FechaAct</label>
                    </div>
                    <div class="col-10">
                      <input
                        type="date"
                        class="form-control"
                        id="fechaAct"
                        name="fechaAct"
                        v-model="datoConsejo.fechaAct"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarConsejo"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarConsejo"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      consejos: [],
      datoConsejo: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 100,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      mostrarBloque: false,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.consejos.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwconsejos/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.consejos = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.consejos.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwconsejos").then((response) => {
        this.consejos = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
        let fin = noPagina * this.elementosPorPagina;
        this.datosPaginados = this.consejos.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["texto"];
      const requiredFieldsText = ["texto"];
      return validarForm(this.datoConsejo, requiredFields, requiredFieldsText);
    },
    async guardarConsejo() {
      if (this.validarForm() === 1) {
        try {
          this.datoConsejo.idUsuarioReg =
            window.sessionStorage.getItem("idUsuario");
          await api.post("/consejos",
            this.datoConsejo
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "Consejo creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarConsejo() {
      if (this.validarForm() === 1) {
        try {
          this.datoConsejo.idUsuarioAct =
            window.sessionStorage.getItem("idUsuarioAct");
          await api.post("/consejos",
            this.datoConsejo
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Consejo creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoConsejo = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idConsejo) {
      this.modalWindow = true;
      if (idConsejo != null) {
        api.get("/vwconsejos/" + idConsejo)
          .then((resp) => {
            this.datoConsejo = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idConsejo) {
      if (idConsejo != null) {
        this.$router.push("/consejo_consperf/" + idConsejo);
      }
    },
    async deleteConsejo(idConsejo) {
      try {
        await api.delete("/consejos/" + idConsejo
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
  },
};
</script>
